let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jZ5rj")).then(() => parcelRequire('3aRXB'));